import { BUITheme } from "@blofin/blofin-ui";
import { UserInfo } from "../Header/types";

/**
 * 更新用户信息并触发 userInfoUpdated 事件
 * @param userInfo - 用户信息
 */
export const updateUserInfo = (userInfo: UserInfo): void => {
  const event = new CustomEvent<UserInfo>("userInfoUpdated", {
    detail: userInfo
  });
  window.dispatchEvent(event);
};

/**
 * 监听 userInfoUpdated 事件
 * @param callback - 当用户信息更新时的回调函数
 */
export const listenerUserInfoUpdated = (callback: (userInfo: UserInfo) => void): void => {
  window.addEventListener("userInfoUpdated", (event: Event) => {
    const customEvent = event as CustomEvent<UserInfo>;
    callback(customEvent.detail);
  });
};

export const updateGlobalTheme = (theme: BUITheme): void => {
  const event = new CustomEvent<BUITheme>("updateGlobalTheme", {
    detail: theme
  });
  window.dispatchEvent(event);
};

export const listenerUpdateGlobalTheme = (callback: (theme: BUITheme) => void): void => {
  window.addEventListener("updateGlobalTheme", (event: Event) => {
    const customEvent = event as CustomEvent<BUITheme>;
    callback(customEvent.detail);
  });
};

/**
 * Header 切换主题/语言时通知各端（如 exchange chatbot）同步 SDK 入参。
 * 字符串须与 apps/blofin-exchange/config/chatbot.ts 中同名常量一致。
 */
export const CHATBOT_PARAMS_SYNC = "chatbot-params-sync";

export type ChatbotParamsSyncDetail = {
  theme?: BUITheme;
  locale?: string;
};

export const dispatchChatbotParamsSync = (detail: ChatbotParamsSyncDetail): void => {
  window.dispatchEvent(new CustomEvent<ChatbotParamsSyncDetail>(CHATBOT_PARAMS_SYNC, { detail }));
};
